/**
 * Animation configuration for each house graphic layer with original staggered intro
 * and continuous floating animation after intro completes
 */
export const graphicAnimations = {
  a: {
    initial: { scale: 0, opacity: 0, x: "-50%", y: "-50%" },
    animate: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.8,
        delay: 0,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  },
  b: {
    initial: { scale: 0, opacity: 0, x: "-50%", y: "-50%" },
    animate: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.8,
        delay: 0.15,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  },
  c: {
    initial: { scale: 0, opacity: 0, x: "-50%", y: "-50%" },
    animate: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.8,
        delay: 0.3,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  },
  d: {
    initial: { scale: 0, opacity: 0, x: "-50%", y: "-50%" },
    animate: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.8,
        delay: 0.45,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  },
} as const;

/**
 * Continuous floating animation variants for after intro completes
 */
export const floatingAnimations = {
  a: {
    scale: [1, 0.9, 1] as number[],
    opacity: 1,
    x: "-50%",
    y: "-50%",
    transition: {
      duration: 4,
      repeat: Infinity,
      ease: "easeInOut" as const,
      delay: 1.2, // Start after intro completes (0.8s + 0.4s buffer)
    },
  },
  b: {
    scale: [1, 0.9, 1] as number[],
    opacity: 1,
    x: "-50%",
    y: "-50%",
    transition: {
      duration: 4,
      repeat: Infinity,
      ease: "easeInOut" as const,
      delay: 1.35, // Staggered start (0.8s + 0.15s + 0.4s buffer)
    },
  },
  c: {
    scale: [1, 0.9, 1] as number[],
    opacity: 1,
    x: "-50%",
    y: "-50%",
    transition: {
      duration: 4,
      repeat: Infinity,
      ease: "easeInOut" as const,
      delay: 1.5, // Staggered start (0.8s + 0.3s + 0.4s buffer)
    },
  },
  d: {
    scale: [1, 0.9, 1] as number[],
    opacity: 1,
    x: "-50%",
    y: "-50%",
    transition: {
      duration: 4,
      repeat: Infinity,
      ease: "easeInOut" as const,
      delay: 1.65, // Staggered start (0.8s + 0.45s + 0.4s buffer)
    },
  },
};
